<template>
  <div class="contact fr">
    <div class="left">
      <div class="fr ac">
        <h1 class="mr40">诚信</h1>
        <h1 class="mr40">合作</h1>
        <h1>共赢</h1>
      </div>
      <p class="fz18 black bold mt40">上海益发物联科技有限公司</p>
      <p
        class="fz14 black mt10"
        style="line-height:16px;"
      >上海益发物联科技有限公司（前身上海凯耀工业皮带）1996年成立于上海，自96年引进欧洲进口特氟龙产品至今已有20年的专业服务经验</p>
      <div class="mt50">
        <p class="fz14 mb10">地址：上海市松江天马开发区天峰路141号</p>
        <p class="fz14 mb10">邮编：201603</p>
        <p class="fz14 mb10">电话：021-57663636 57663696</p>
        <p class="fz14 mb10">手机：13901698839</p>
        <p class="fz14 mb10">联系人：李松林</p>
        <p class="fz14 mb10">E-mail:efab@efab.com.cn</p>
      </div>
    </div>
    <div class="right">
      <img src="https://img.beltdance.com/images/20251124/1992844941923467264.png" style="width: 100%;height: 100%">
    </div>
  </div>
</template>

<script>
export default {
  props: {},
  data() {
    return {
      center: { lng: 121.138139, lat: 31.07999 },
      zoom: 17,
      infoWindow: {
        show: true,
        contents: "",
      },
    };
  },
  computed: {},
  created() {},
  mounted() {},
  watch: {},
  methods: {
    infoWindowClose(e) {
      this.infoWindow.show = false;
    },
    infoWindowOpen(e) {
      this.infoWindow.show = true;
    },
  },
  components: {},
};
</script>

<style scoped lang="scss">
.contact {
  width: 1200px;
  height: 500px;
  background-color: #fff;
  margin: 0 auto;
  margin-top: 20px;
  margin-bottom: 20px;
  border: 1px solid #707070;
  padding: 50px 30px;
  .left {
    width: 40%;
    height: 100%;
    h1 {
      font-size: 40px;
      font-weight: bold;
    }
  }
  .right {
    width: calc(60% - 20px);
    height: 100%;
    margin-left: 20px;
    border: 1px solid #e5e5e5;
    .map {
      width: 100%;
      height: 100%;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/page/homePage/homeContact/index.vue